module.exports = __webpack_public_path__ + "img/switch.177fcfee.svg";